import { _apiV2_get, _apiV2_post } from "@/app/api2"
import {
  UserPreferencesProps,
  UserProfileResponse,
  UserProfileUpdateRequestBody,
  UserTicketRequestBody,
} from "@/app/types"

// ########## User API ##########
export async function apiv2_fetchUserProfile(): Promise<UserProfileResponse> {
  return _apiV2_get("/users/me/profile", {
    key: "userProfile",
    cacheLS: true,
  })
}

export async function apiv2_updateUserProfile(
  data: UserProfileUpdateRequestBody
): Promise<any> {
  return _apiV2_post("/users/me/profile", {
    key: "userProfile",
    cacheLS: true,
    body: data,
  })
}

export async function apiv2_fetchUserPreferences(): Promise<UserPreferencesProps> {
  return _apiV2_get("/users/me/preferences", {
    key: "userPreferences",
    cacheLS: true,
  })
}

export async function apiv2_updateUserPreferences(
  data: UserPreferencesProps
): Promise<UserPreferencesProps> {
  return _apiV2_post("/users/me/preferences", {
    key: "userPreferences",
    cacheLS: true,
    body: data,
  })
}

export async function apiv2_createUserTicket(
  data: UserTicketRequestBody,
  shouldBeAuthenticated: boolean = true
) {
  return _apiV2_post("/users/me/tickets", {
    key: "userTickets",
    body: data,
    isAuthNeeded: shouldBeAuthenticated,
  })
}

export async function apiv2_requestPasswordReset() {
  return _apiV2_post("/users/me/reset-password", {
    key: "userResetPassword",
  })
}
